<template>
    <div class="comp-erpsku">
        <TableList
            v-bind="getTableProps"
            @on-check-change="handleCheck"
        ></TableList>
    </div>
</template>

<script>
import TableList from "./tablelist";
import { mapState } from "vuex";
import {
    HttpGetSkuAndAsinList,
    HttpGetSkuAndAsinByManagementList,
} from "../../service/base";
export default {
    props: ["isManage"],
    components: {
        TableList,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("boss", ["accounts"]),
        getTableProps() {
            let widthStyle = "width: 120px;";
            let searchsData = [
                {
                    label: "ASIN",
                    tag: "vInput",
                    key: "CN_asin",
                    show: true,
                    style: widthStyle,
                },
                {
                    label: "SELLER SKU",
                    tag: "vInput",
                    key: "CN_sellerSku",
                    show: true,
                    style: widthStyle,
                },
                {
                    label: "店铺",
                    key: "CN_accountFlag",
                    tag: "vSelect",
                    show: true,
                    options: this.accounts.map(function (item) {
                        return {
                            value: item.flag,
                            label: item.flag,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
            ];
            let columns = [
                {
                    title: "No.",
                    type: "index",
                    width: 60,
                },
                {
                    title: "Listing Img",
                    // width:200,
                    render: (h, { row }) => {
                        let image = row.imageUrl;
                        if (image) {
                            return (
                                <div>
                                    <div style="float: left; cursor: pointer; margin-right: 10px;">
                                        <img
                                            style="width: 100px; height: 100px;"
                                            src={image}
                                        ></img>
                                    </div>
                                </div>
                            );
                        } else {
                            return (
                                <div>
                                    <div>
                                        <span>-</span>
                                    </div>
                                </div>
                            );
                        }
                    },
                },
                {
                    title: "ASIN",
                    key: "asin",
                },
                {
                    title: "SELLER SKU",
                    key: "sellerSku",
                },
                {
                    title: "店铺",
                    key: "accountFlag",
                },
            ];
            let operate = {
                title: this.$t("global.common.actions", {
                    defaultValue: "操作",
                }),
                width: 120,
                align: "center",
                render: (h, { row }) => {
                    return h(
                        "vButton",
                        {
                            props: {
                                theme: "primary",
                            },
                            nativeOn: {
                                click: () => {
                                    this.$emit("on-data", row);
                                },
                            },
                        },
                        this.$t("fbb.inbound.choose", { defaultValue: "选择" })
                    );
                },
            };
            columns.push(operate);
            return {
                Searchs: {
                    show: true,
                },
                ajaxRequest: async (params) => {
                    let ajaxFunction = HttpGetSkuAndAsinList;
                    if (this.isManage) {
                        ajaxFunction = HttpGetSkuAndAsinByManagementList;
                    }
                    return await ajaxFunction(params);
                },
                // interceptRequest: (params) => {
                //     let { search, ...other } = params;
                //     let { IN_erpSku, ...otherSearch } = search;
                //     if (IN_erpSku) {
                //         IN_erpSku = IN_erpSku.split(/\n/);
                //     }
                //     return {
                //         ...other,
                //         search: {
                //             ...otherSearch,
                //             IN_erpSku,
                //         },
                //     };
                // },
                SearchsData: searchsData,
                columns,
            };
        },
    },
    methods: {
        handleCheck(checked) {
            this.checked = checked.map((item) => {
                return item.erpSku;
            });
        },
        confirm() {
            this.$emit("on-data", this.checked);
        },
    },
};
</script>

<style></style>
